import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3382e944"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"25% !important","margin-bottom":"15px"} }
const _hoisted_2 = { style: {"width":"15% !important","margin-bottom":"15px","overflow":"hidden"} }
const _hoisted_3 = {
  key: 0,
  style: {"width":"100% !important"}
}
const _hoisted_4 = { style: {"width":"100% !important"} }
const _hoisted_5 = { style: {"width":"100% !important","background-color":"#409eff"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 要素名称 ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"71% !important","color":"#fff","text-align":"center"} }, " 子要素 ", -1))
const _hoisted_8 = { style: {"float":"left","width":"10% !important","text-align":"right","overflow":"hidden"} }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["title"]
const _hoisted_11 = { style: {"float":"left","width":"81% !important"} }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  style: {"width":"100% !important","padding-bottom":"10px","padding-top":"10px","border-bottom":"1px solid #efefef","text-align":"center","height":"40px","line-height":"40px"}
}
const _hoisted_16 = { style: {"width":"100% !important","background-color":"#409eff"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 供应商名称 ")
], -1))
const _hoisted_18 = { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }
const _hoisted_19 = { style: {"border-right":"1px solid #efefef","width":"100%"} }
const _hoisted_20 = { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }
const _hoisted_21 = { style: {"border-right":"1px solid #efefef","width":"100%"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 交货时间 ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"19% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 存放地点 ")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"5% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, "操作")
], -1))
const _hoisted_25 = {
  key: 0,
  style: {"padding-top":"10px"}
}
const _hoisted_26 = { style: {"float":"left","width":"19% !important","text-align":"center"} }
const _hoisted_27 = { style: {"float":"left"} }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { style: {"float":"left","width":"19% !important","text-align":"center"} }
const _hoisted_30 = { style: {"float":"left","width":"19% !important","text-align":"center"} }
const _hoisted_31 = { style: {"float":"left","width":"19% !important","text-align":"center"} }
const _hoisted_32 = { style: {"float":"left","width":"19% !important","text-align":"center"} }
const _hoisted_33 = { style: {"float":"left","width":"5% !important","text-align":"center"} }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  style: {"width":"100%","text-align":"center","line-height":"60px","height":"40px"}
}
const _hoisted_36 = { style: {"margin-top":"5px"} }
const _hoisted_37 = {
  key: 2,
  style: {"width":"100% !important"}
}
const _hoisted_38 = { style: {"width":"100% !important"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_Check = _resolveComponent("Check")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_miezz_form, {
      ref: "ruleForm",
      modelValue: _ctx.form,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form) = $event)),
      fix: true,
      key: _ctx.random
    }, {
      "form-item": _withCtx(({ item }) => [
        (item.Prop == 'ProductName')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.product.Data.Name), 1)
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'Name')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.form.Data.Name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.Name) = $event)),
                  onChange: _ctx.onChangeName,
                  placeholder: '请填写'
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'Weight')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.form.Data.Weight,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.Weight) = $event)),
                  onHandleBlur: _ctx.onChangeWeight,
                  placeholder: '请填写'
                }, {
                  suffix: _withCtx(() => [
                    _createTextVNode(" KGS ")
                  ]),
                  _: 1
                }, 8, ["modelValue", "onHandleBlur"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'SpecImages')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_upload, {
                  modelValue: _ctx.form.Data.SpecImages,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.SpecImages) = $event)),
                  path: "product/spec",
                  accept: "image/*",
                  prop: "Url",
                  maxSize: 10 * 1024 * 1024
                }, null, 8, ["modelValue"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'Number')
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 4 }, {
              label: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, [
                  _createVNode(_component_el_form_item, {
                    style: {"float":"left","padding":"0px","margin":"0px","width":"99% !important"},
                    prop: "Number"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.Data.Number,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.Number) = $event)),
                        style: {"width":"100% !important"},
                        placeholder: "请填写",
                        disabled: (_ctx.form.Data.CompanyBusinessCardId!=null && _ctx.form.Data.CompanyBusinessCardId!=undefined && _ctx.form.Data.CompanyBusinessCardId!='')?false:true,
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeNumber())),
                        class: "input-with-select"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            clearable: "",
                            filterable: "",
                            modelValue: _ctx.form.Data.CompanyBusinessCardId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.CompanyBusinessCardId) = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeCompanyBusinessCardId())),
                            placeholder: "请选择货号所属人",
                            style: {"width":"180px !important","background-color":"#fff"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companys, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.Value,
                                  label: item.Label,
                                  value: item.Value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "disabled"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.SpecNumbers, (p, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    style: {"width":"25% !important","margin-bottom":"15px"},
                    key: index
                  }, [
                    _createVNode(_component_el_form_item, {
                      style: _normalizeStyle([{"padding":"0px","margin":"0px","width":"99% !important"}, index % 4 == 0 || index % 4 == 3 ? 'float:left;' : 'float:right;']),
                      prop: `SpecNumbers[${index}].Name`,
                      rules: _ctx.form.Rules.SpecNumbers_Name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: p.Name,
                          "onUpdate:modelValue": ($event: any) => ((p.Name) = $event),
                          disabled: (p.CompanyBusinessCardId!=null && p.CompanyBusinessCardId!=undefined && p.CompanyBusinessCardId!='')?false:true,
                          style: {"width":"100% !important"},
                          placeholder: "请填写",
                          class: "inputDelete",
                          onChange: ($event: any) => (_ctx.onChangeSpecNumber(p))
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              clearable: "",
                              filterable: "",
                              modelValue: p.CompanyBusinessCardId,
                              "onUpdate:modelValue": ($event: any) => ((p.CompanyBusinessCardId) = $event),
                              placeholder: "请选择货号所属人",
                              onChange: ($event: any) => (_ctx.onChangeSpecNumberCompanyBusinessCardId(index)),
                              style: {"width":"180px !important","background-color":"#fff"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companys, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.Value,
                                    label: item.Label,
                                    value: item.Value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          suffix: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              style: {"cursor":"pointer","font-size":"12px"},
                              onClick: ($event: any) => (_ctx.onDeleteCompany(index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Close)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["style", "prop", "rules"])
                  ]))
                }), 128)),
                _createElementVNode("span", _hoisted_2, [
                  _createElementVNode("span", {
                    style: {"cursor":"pointer"},
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onAddCompany()))
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 货号")
                  ])
                ]),
                (_ctx.isInit == false && _ctx.companys !=null && _ctx.companys !=undefined && _ctx.companys.length <= 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(_component_el_alert, {
                          title: "暂无境外收货人/境外发货人/生产销售单位/消费使用单位信息，请在组织/公司/相关参数处管理",
                          type: "warning",
                          "show-icon": "",
                          closable: false
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.Prop == 'SpecElements')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              prop: item.Prop,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.isSpecElementAdd == true)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          style: {"padding-right":"10px","color":"#fff","cursor":"pointer"},
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSpec()))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          }),
                          _createTextVNode("规格要素")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.productSpecElements != null && _ctx.productSpecElements.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productSpecElements, (p, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: {"width":"100% !important","padding-bottom":"10px","padding-top":"10px"},
                          key: index
                        }, [
                          _createElementVNode("div", {
                            style: {"float":"left","width":"19% !important","text-align":"center","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                            title: p.Name
                          }, _toDisplayString(p.Name), 9, _hoisted_10),
                          _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.ProductSpecElementItems, (p1, index1) => {
                              return (_openBlock(), _createElementBlock("div", {
                                style: {"float":"left","margin-left":"0px","overflow":"hidden","height":"40px"},
                                key: index1
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(
                    p1.IsSelected == true
                      ? 'div-category-select'
                      : 'div-category'
                  )
                                }, [
                                  _createElementVNode("div", {
                                    title: p1.Name,
                                    style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                  }, _toDisplayString(p1.Name), 9, _hoisted_12)
                                ], 2),
                                (p1.IsSelected == false)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      style: {"position":"relative","border-radius":"2px","width":"14px","height":"14px","border":"1px solid #ccc","top":"-27px","left":"15px","cursor":"pointer"},
                                      onClick: ($event: any) => (_ctx.onSelectCategory(p.Id, p1.Id))
                                    }, null, 8, _hoisted_13))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      style: {"text-indent":"1px","position":"relative","border-radius":"2px","width":"14px","height":"14px","border":"1px solid #409eff","top":"-27px","left":"15px","cursor":"pointer","line-height":"14px","background-color":"#409eff","color":"#ffffff","font-size":"10px"},
                                      onClick: ($event: any) => (_ctx.onSelectCategory(p.Id, p1.Id))
                                    }, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Check)
                                        ]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_14))
                              ]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, " 暂无数据 "))
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (
          item.Prop == 'SpecStocks' &&
          _ctx.ProductManagement_ProductManagement_ProductInformation_SpecificationAndModel_InventoryInformation ==
            true
        )
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              prop: item.Prop,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, " 数量（" + _toDisplayString(_ctx.product.Data.ChargeUnithZh) + "） ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, " 采购价/" + _toDisplayString(_ctx.product.Data.ChargeUnithZh), 1)
                  ]),
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24
                ]),
                (
                     _ctx.form.Data.SpecStocks !=undefined && _ctx.form.Data.SpecStocks.length>
                    0
                    )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.SpecStocks, (p, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: {"clear":"both","width":"100% !important"},
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              prop: `SpecStocks[${index}].Supplier`,
                              rules: _ctx.form.Rules.SpecStocks_Supplier
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: p.Supplier,
                                  "onUpdate:modelValue": ($event: any) => ((p.Supplier) = $event),
                                  style: {"width":"99% !important"},
                                  filterable: "",
                                  onChange: ($event: any) => (_ctx.onChangeSupplier(index)),
                                  "allow-create": "",
                                  "default-first-option": "",
                                  "reserve-keyword": false,
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockCompanys, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.Label,
                                        label: item.Label,
                                        value: item.Label
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_27, _toDisplayString(item.Label), 1),
                                          (item.Data.IsCompany != true)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"},
                                                onClick: ($event: any) => (_ctx.onDeleteSupplier(p, item,index))
                                              }, [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_Delete)
                                                  ]),
                                                  _: 1
                                                })
                                              ], 8, _hoisted_28))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              prop: `SpecStocks[${index}].Quantity`,
                              rules: _ctx.form.Rules.SpecStocks_Quantity
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  onHandleBlur: ($event: any) => (_ctx.onChangeQuantity(index)),
                                  modelValue: p.Quantity,
                                  "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                                  placeholder: '请填写',
                                  style: {"width":"99% !important"}
                                }, null, 8, ["onHandleBlur", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: p.Price,
                                  "onUpdate:modelValue": ($event: any) => ((p.Price) = $event),
                                  style: {"width":"99% !important"},
                                  placeholder: "请填写",
                                  onBlur: ($event: any) => (_ctx.onChangePrice(index)),
                                  class: "input-with-select"
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      clearable: "",
                                      filterable: "",
                                      modelValue: p.CurrencyId,
                                      "onUpdate:modelValue": ($event: any) => ((p.CurrencyId) = $event),
                                      placeholder: "请选择",
                                      style: {"width":"130px !important","background-color":"#fff"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencys, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.Value,
                                            label: item.Label,
                                            value: item.Value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_el_date_picker, {
                              modelValue: p.DeliveryTime,
                              "onUpdate:modelValue": ($event: any) => ((p.DeliveryTime) = $event),
                              style: {"width":"99% !important"},
                              type: "date",
                              "value-format": "YYYY/MM/DD",
                              placeholder: "请选择"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_miezz_input, {
                              modelValue: p.Address,
                              "onUpdate:modelValue": ($event: any) => ((p.Address) = $event),
                              placeholder: '请填写',
                              style: {"width":"99% !important"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("span", {
                              style: {"cursor":"pointer","color":"red"},
                              onClick: ($event: any) => (_ctx.onDeleteStock(index))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_34)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, " 暂无数据 ")),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onAddStock())),
                    style: {"color":"#faad6a","cursor":"pointer","font-weight":"900","font-size":"14px"}
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 新增")
                  ])
                ]),
                (_ctx.isInit==false && _ctx.currencys !=null && _ctx.currencys !=undefined && _ctx.currencys.length <= 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, [
                        _createVNode(_component_el_alert, {
                          title: "暂无币制信息，请在系统/参数管理/币制处管理",
                          type: "warning",
                          "show-icon": "",
                          closable: false
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"])
  ], 64))
}